module.exports = __webpack_public_path__ + "static/media/3DPPA24.b329b80f.jpg";